import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';

import { DataGrid, GridToolbar, gridClasses, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useGetAgenciesQuery } from '../../slices/agencyApiSlice';
import { Card } from 'react-bootstrap';


const AgencyListScreen = () => {
  const navigate = useNavigate();
  const { data: agencies, isLoading, error , refetch: refetchAgencies} = useGetAgenciesQuery();

const CustomToolbar = () => (
  <div style={{ padding: '0.5rem 1rem' }}>
    <GridToolbarQuickFilter />
  </div>
);

  const columns = [
    { field: 'agencyName', headerName: 'Name', flex: 1 },
    { field: 'agencyAddress', headerName: 'Address', flex: 1 },
    { field: 'agencyPhone', headerName: 'Phone', flex: 1 },
    { field: 'agencyEmail', headerName: 'Email', flex: 1 },
    { field: 'agencyTier', headerName: 'Tier', flex: 1 },
    { field: 'daysToShiftStart', headerName: 'Days to View', flex: 1 },
    {
      field: 'isApproved',
      headerName: 'Approved',
      flex: 0.6,
      renderCell: (params) => (
        <Chip
          size="small"
          label={params.value ? 'Approved' : 'Pending'}
          color={params.value ? 'success' : 'warning'}
        />
      ),
    },
    {
      field: 'isActive',
      headerName: 'Active',
      flex: 0.6,
      renderCell: (params) => (
        <Chip
          size="small"
          label={params.value ? 'Active' : 'Inactive'}
          color={params.value ? 'success' : 'default'}
        />
      ),
    },
    {
      field: 'edit',
      headerName: 'Edit',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => navigate(`/admin/agencies/${params.row._id}/edit`)}
        >
          Edit
        </Button>
      ),
    },
  ];

//custom-card-bg
useEffect(() => {
  if (agencies) {
    refetchAgencies();
  }
}, []);

 const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 1,
      bottom: params.isLastVisible ? 0 : 1,
    };
  }, []);

/*

slots={{ toolbar: GridToolbar }}
          slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}*/



  return (
    <Box sx={{ p: 3 }}>

      <Card className="mb-4 custom-card-bg2">
        <Card.Header className="fw-bold">Agency Information</Card.Header>
        <Card.Body>

       
      <Typography variant="h4" gutterBottom>
        Agency List
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
        onClick={() => navigate('/admin/agencies/create')}
      >
        Create New Agency
      </Button>

      {isLoading ? (
        <Typography>Loading...</Typography>
      ) : error ? (
        <Typography color="error">Error: {error.message}</Typography>
      ) : (
        <DataGrid
        density='compact'
          rows={agencies || []}
          getRowId={(row) => row._id}
          columns={columns}
          autoHeight
          pageSize={10}
          getRowSpacing={getRowSpacing}
          rowsPerPageOptions={[10, 20, 50]}
          
          slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        />
      )}

        </Card.Body>
            </Card>

    </Box>
  );
};

export default AgencyListScreen;
